import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "../utils/usePageMeta";
import { ReactComponent as IGWhite } from "../assets/ig_icon_white.svg";
import tempoCourts from "../assets/tempo_courts1.webp";
import tempoPickleball from "../assets/tempo_pickleball1.webp";
import sauna from "../assets/sauna.webp";
import LocationsMenu from "../components/LocationsMenu";
import "./HomePage.css";

const BOOK_URL = "https://app.playtomic.io/tenants/8466df30-5b02-492a-8cda-7bd631040099";

const ArrowIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M3 8l3 3 7-7" />
  </svg>
);

const TempoWordmark = () => (
  <svg viewBox="0 0 945.25 184.75" aria-hidden="true">
    <g>
      <path d="M77.3,119.4c-6.78,0-13.18-1.66-18.83-4.58c-0.31-0.16-0.61-0.31-0.92-0.48v1.04v33.45v0.95v30.87h39.48v-30.87v-0.95v-33.45v-1.04c-0.3,0.17-0.61,0.32-0.92,0.48C90.48,117.74,84.08,119.4,77.3,119.4z" />
      <path d="M77.3,4.1c-40.9,0-74.18,33.28-74.18,74.18c0,4.94,0.5,9.77,1.42,14.44c0.06,0.31,0.12,0.61,0.19,0.92h0.94h32.52h0.98c-0.12-0.3-0.25-0.61-0.36-0.92c-1.69-4.5-2.63-9.36-2.63-14.44c0-22.67,18.44-41.11,41.11-41.11c22.67,0,41.11,18.44,41.11,41.11c0,5.08-0.93,9.95-2.63,14.44c-0.12,0.31-0.24,0.61-0.36,0.92h0.98h32.52h0.94c0.06-0.3,0.13-0.61,0.19-0.92c0.93-4.67,1.42-9.5,1.42-14.44C151.48,37.38,118.2,4.1,77.3,4.1z" />
      <path d="M233.58,155.6V53.72h-36.31V29.15h101.16v24.57h-36.49V155.6H233.58z" />
      <path d="M355.46,155.6V29.15h83.1v24.57h-54.55v22.94h46.06v24.57h-46.06v29.81h54.55v24.57H355.46z" />
      <path d="M495.59,155.6V29.15h33.96l30.89,77.5l29.99-77.5h33.96V155.6h-28.54V79.55l-24.39,61.24h-22.94l-24.39-61.42v76.23H495.59z" />
      <path d="M681.43,155.6V29.15h50.22c8.67,0,16.5,1.57,23.48,4.7c6.98,3.13,12.49,7.65,16.53,13.55c4.03,5.9,6.05,12.95,6.05,21.13c0,8.07-1.96,15.08-5.87,21.04c-3.91,5.96-9.33,10.57-16.26,13.82c-6.93,3.25-14.9,4.88-23.94,4.88h-21.68v47.33H681.43z M709.97,83.88h20.95c6.74,0,11.41-1.54,14-4.61c2.59-3.07,3.88-6.65,3.88-10.75c0-3.85-1.3-7.32-3.88-10.39c-2.59-3.07-7.26-4.61-14-4.61h-20.95V83.88z" />
      <path d="M875.84,157.77c-8.67,0-16.95-1.51-24.84-4.52c-7.89-3.01-14.93-7.34-21.14-13.01c-6.2-5.66-11.08-12.52-14.63-20.59c-3.55-8.07-5.33-17.16-5.33-27.28c0-10.12,1.78-19.21,5.33-27.28c3.55-8.07,8.43-14.93,14.63-20.59c6.2-5.66,13.25-9.99,21.14-13.01c7.89-3.01,16.17-4.52,24.84-4.52c8.67,0,16.98,1.51,24.93,4.52c7.95,3.01,15.02,7.35,21.23,13.01c6.2,5.66,11.11,12.53,14.72,20.59c3.61,8.07,5.42,17.16,5.42,27.28c0,10.12-1.81,19.21-5.42,27.28c-3.61,8.07-8.52,14.93-14.72,20.59c-6.2,5.66-13.28,10-21.23,13.01C892.82,156.26,884.51,157.77,875.84,157.77z M875.84,131.94c5.9,0,11.68-1.45,17.34-4.34c5.66-2.89,10.32-7.25,14-13.1c3.67-5.84,5.51-13.22,5.51-22.13c0-9.03-1.87-16.47-5.6-22.31c-3.73-5.84-8.43-10.18-14.09-13.01c-5.66-2.83-11.38-4.25-17.16-4.25s-11.47,1.42-17.07,4.25c-5.6,2.83-10.24,7.17-13.91,13.01c-3.67,5.84-5.51,13.28-5.51,22.31c0,8.91,1.81,16.29,5.42,22.13c3.61,5.84,8.22,10.21,13.82,13.1C864.19,130.49,869.94,131.94,875.84,131.94z" />
    </g>
  </svg>
);

function useFadeIn(deps: React.DependencyList = []) {
  const rootRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!rootRef.current) return;
    const targets = rootRef.current.querySelectorAll(
      ".v2-sec-head, .v2-pillar, .v2-plan, .v2-bigimg, .v2-callout"
    );
    targets.forEach((el) => el.classList.add("fade-in"));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return rootRef;
}

function useHoustonClock(): string {
  const [now, setNow] = useState<string>("— : — CT");
  useEffect(() => {
    const tick = () => {
      const d = new Date();
      const t = d.toLocaleTimeString("en-US", {
        timeZone: "America/Chicago",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
      setNow(`${t} CT`);
    };
    tick();
    const id = window.setInterval(tick, 30000);
    return () => window.clearInterval(id);
  }, []);
  return now;
}

function HomePage() {
  usePageMeta({
    title: "TEMPO | Padel & Pickleball Club in Houston, Texas",
    description:
      "Houston's premier padel and pickleball club. 5 outdoor padel courts, 4 pickleball courts, sauna, ice bath, bar & lounge. Book courts, join memberships, or try a free intro lesson.",
    canonicalPath: "/",
  });

  const rootRef = useFadeIn([]);
  const clock = useHoustonClock();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("v2-menu-open", menuOpen);
    return () => document.body.classList.remove("v2-menu-open");
  }, [menuOpen]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const closeMenu = () => setMenuOpen(false);
  const goBook = () => {
    window.location.href = BOOK_URL;
  };

  return (
    <div className="home-v2" ref={rootRef}>
      {/* NAV */}
      <header className={`v2-nav ${scrolled ? "scrolled" : ""} ${menuOpen ? "solid" : ""}`}>
        <div className="v2-container v2-nav-inner">
          <div className="v2-nav-left">
            <a
              href="https://www.instagram.com/tempopadelclub"
              target="_blank"
              rel="noopener noreferrer"
              className="v2-nav-ig"
              aria-label="Tempo on Instagram"
            >
              <IGWhite />
            </a>
            <Link to="/">Home</Link>
            <LocationsMenu home enabled={!menuOpen} />
          </div>
          <Link to="/" className="v2-nav-logo" aria-label="Tempo — home">
            <TempoWordmark />
          </Link>
          <div className="v2-nav-right">
            <Link to="/mornings">Mornings</Link>
            <Link to="/events">Events</Link>
            <Link to="/coaching">Coaching</Link>
            <a href="#membership">Pricing</a>
            <Link to="/free-intro">Free Intro</Link>
            <a href="#visit">Contact</a>
            <button type="button" className="v2-nav-cta" onClick={goBook}>
              <span className="dot"></span> Book Now
            </button>
            <button
              type="button"
              className={`v2-menu-toggle ${menuOpen ? "open" : ""}`}
              aria-label="Open menu"
              aria-expanded={menuOpen}
              aria-controls="v2-mobile-drawer"
              onClick={() => setMenuOpen((v) => !v)}
            >
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* MOBILE DRAWER */}
      <nav
        className={`v2-mobile-drawer ${menuOpen ? "open" : ""}`}
        id="v2-mobile-drawer"
        aria-label="Mobile"
      >
        <Link to="/" className="m-link" onClick={closeMenu}>
          <span>Home</span>
          <span className="idx">01</span>
        </Link>
        <Link to="/mornings" className="m-link" onClick={closeMenu}>
          <span>Mornings</span>
          <span className="idx">02</span>
        </Link>
        <Link to="/events" className="m-link" onClick={closeMenu}>
          <span>Events</span>
          <span className="idx">03</span>
        </Link>
        <Link to="/coaching" className="m-link" onClick={closeMenu}>
          <span>Coaching</span>
          <span className="idx">04</span>
        </Link>
        <a href="#membership" className="m-link" onClick={closeMenu}>
          <span>Pricing</span>
          <span className="idx">05</span>
        </a>
        <Link to="/free-intro" className="m-link" onClick={closeMenu}>
          <span>Free Intro</span>
          <span className="idx">06</span>
        </Link>
        <a href="#visit" className="m-link" onClick={closeMenu}>
          <span>Contact</span>
          <span className="idx">07</span>
        </a>
        <LocationsMenu home mobile enabled={menuOpen} onNavigate={closeMenu} />
        <button
          type="button"
          className="m-cta"
          onClick={() => {
            closeMenu();
            goBook();
          }}
        >
          <span className="dot"></span> Book Now
        </button>
        <div className="m-foot">
          <span>1729 Brittmoore Rd</span>
          <span>Houston, TX 77043</span>
          <span>+1 713 570 6716</span>
        </div>
      </nav>

      {/* HERO */}
      <section className="v2-hero">
        <div
          className="bgimg"
          role="img"
          aria-label="Tempo padel club at dusk"
          style={{ backgroundImage: `url(${tempoCourts})` }}
        />
        <div className="v2-hero-inner">
          <div className="v2-hero-top">
            <span>EST. 2024 — HOUSTON, TEXAS</span>
            <div className="loc">
              <span>29.78°N / 95.56°W</span>
              <span>{clock}</span>
            </div>
          </div>

          <div className="v2-hero-content">
            <h1 className="v2-hero-title">
              <span className="row">Find Your</span>
              <span className="row">
                <span className="accent">Tempo.</span>
              </span>
            </h1>

            <div className="v2-hero-meta">
              <div className="v2-hero-lede">
                <span className="kicker">A padel &amp; pickleball club</span>
                Five glass-walled padel courts, four pickleball courts, sauna, ice
                bath, and a lounge built for unwinding. Houston's home for the
                world's fastest-growing racquet sports.
                <div className="v2-hero-actions">
                  <button
                    type="button"
                    className="v2-btn v2-btn-primary"
                    onClick={goBook}
                  >
                    Book a Court
                    <ArrowIcon />
                  </button>
                  <Link to="/free-intro" className="v2-btn v2-btn-ghost">
                    Free Intro Lesson
                  </Link>
                </div>
              </div>
              <div className="v2-hero-stats">
                <div className="cell">
                  <span className="n">5</span>
                  <span className="l">Padel courts</span>
                </div>
                <div className="cell">
                  <span className="n">4</span>
                  <span className="l">Pickleball courts</span>
                </div>
                <div className="cell">
                  <span className="n">7am–11:30pm</span>
                  <span className="l">Daily hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="v2-hero-scroll">
          <span>Scroll</span>
        </div>
      </section>

      {/* HEIGHTS */}
      <section className="v2-section v2-heights" id="heights" aria-labelledby="heights-heading">
        <div className="v2-container v2-heights-inner">
          <div>
            <h2 id="heights-heading">Tempo <em>Heights</em></h2>
            <span className="v2-heights-status">Coming soon</span>
          </div>
          <div className="v2-heights-details">
            <span className="mono">02 / Houston, Texas</span>
            <p>Our second Houston location is coming to <strong>8200 Washington Ave.</strong></p>
          </div>
        </div>
      </section>

      {/* EXPERIENCE */}
      <section className="v2-section noborder" id="experience">
        <div className="v2-container">
          <div className="v2-sec-head">
            <div className="left">
              <span className="label">The Experience</span>
            </div>
            <h2>
              More <em>than</em> a game. A way to <em>move.</em>
            </h2>
          </div>
        </div>

        <div className="v2-pillars v2-container">
          <div className="v2-pillar">
            <h3>
              Courts.<span className="sub">— built for the sport</span>
            </h3>
            <p>
              Five regulation padel courts with 360° glass and panoramic
              sightlines. Four pickleball courts with dedicated coaching, leagues,
              and open-play windows every day of the week.
            </p>
            <div className="meta">
              <div className="cell">
                <span className="n">5</span>
                <span className="l">Padel</span>
              </div>
              <div className="cell">
                <span className="n">4</span>
                <span className="l">Pickleball</span>
              </div>
              <div className="cell">
                <span className="n">7 days</span>
                <span className="l">A week</span>
              </div>
            </div>
          </div>

          <div className="v2-pillar">
            <h3>
              Recover.<span className="sub">— 37° &rarr; 230°F</span>
            </h3>
            <p>
              Step off the court, into the sauna, then the ice bath. Hot and cold
              therapy designed to flush the match and put you back together —
              faster, looser, steadier.
            </p>
            <div className="meta">
              <div className="cell">
                <span className="n">230°</span>
                <span className="l">Sauna F</span>
              </div>
              <div className="cell">
                <span className="n">37°</span>
                <span className="l">Plunge F</span>
              </div>

            </div>
          </div>

          <div className="v2-pillar">
            <h3>
              Unwind.<span className="sub">— bar &amp; lounge</span>
            </h3>
            <p>
              Pre-match espresso, post-match pour. A lounge and bar built so the
              game doesn't end when the match does — it's where the rhythm of the
              club lives.
            </p>
            <div className="meta">
              <div className="cell">
                <span className="n">7am</span>
                <span className="l">Opens</span>
              </div>
              <div className="cell">
                <span className="n">11:30pm</span>
                <span className="l">Closes</span>
              </div>
              <div className="cell">
                <span className="n">Daily</span>
                <span className="l">Service</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COURTS */}
      <section className="v2-section" id="courts">
        <div className="v2-container">
          <div className="v2-sec-head">
            <div className="left">
              <span className="label">The Courts / Brittmoore</span>
            </div>
            <h2>
              Nine courts. <em>Your</em> club.
            </h2>
          </div>

          <div className="v2-bigimg">
            <img src={tempoCourts} alt="Tempo padel courts" />
            <div className="overlay">
              <div className="top">
                <span>01 / PADEL / OUTDOOR</span>
                <span>GLASS · 10M × 20M</span>
              </div>
              <div className="bottom">
                <div className="cap">
                  Doubles only.
                  <br />
                  Walls in play.
                </div>
                <div className="specs">
                  <span>SURFACE · TURF</span>
                  <span>LIGHTING · LED</span>
                  <span>BOOK · 24/7</span>
                </div>
              </div>
            </div>
          </div>

          <div className="v2-courts-pair">
            <div className="v2-bigimg aspect-43">
              <img src={tempoPickleball} alt="Pickleball courts" />
              <div className="overlay">
                <div className="top">
                  <span>02 / PICKLEBALL</span>
                  <span>4 COURTS</span>
                </div>
                <div className="bottom">
                  <div className="cap">The most social court in the club.</div>
                  <div className="specs">
                    <span>OPEN PLAY</span>
                    <span>LADDER</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="v2-bigimg aspect-43">
              <img src={sauna} alt="Sauna and cold plunge" />
              <div className="overlay">
                <div className="top">
                  <span>03 / WELLNESS</span>
                  <span>SAUNA · ICE</span>
                </div>
                <div className="bottom">
                  <div className="cap">
                    Hot, then cold.
                    <br />
                    In that order.
                  </div>
                  <div className="specs">
                    <span>MEMBERS ONLY</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CALLOUT */}
      <section className="v2-section" id="learn">
        <div className="v2-container">
          <div className="v2-sec-head">
            <div className="left">
              <span className="label">New To The Sport?</span>
            </div>
            <h2>
              Two ways <em>in.</em>
            </h2>
          </div>

          <div className="v2-callout-grid">
            <div className="v2-callout dark">
              <span className="kicker">Free Intro Lesson</span>
              <h3>
                Your first hour <em>is on us.</em>
              </h3>
              <p className="v2-callout-muted">
                No gear, no experience, no excuses. We'll put a paddle in your
                hand, teach you the rules, and by the end of the hour you'll be
                rallying. It's the fastest introduction to the fastest-growing
                sport in the world.
              </p>
              <div className="v2-callout-cta">
                <Link to="/free-intro" className="v2-btn v2-btn-primary">
                  Claim Free Lesson
                  <ArrowIcon />
                </Link>
              </div>
            </div>

            <div className="v2-callout">
              <span className="kicker">Mornings at Tempo</span>
              <h3>
                Start your day <em>on glass.</em>
              </h3>
              <p className="v2-callout-muted">
                A weekly rhythm of morning open play and free intro slots —
                Wednesday, Thursday, Friday, and Saturday. Beat the heat, meet regulars, and
                find your tempo before the workday begins.
              </p>
              <div className="v2-callout-cta">
                <Link to="/mornings" className="v2-btn v2-btn-on-light">
                  See Mornings
                  <ArrowIcon />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MEMBERSHIP */}
      <section className="v2-section" id="membership">
        <div className="v2-container">
          <div className="v2-sec-head">
            <div className="left">
              <span className="label">Membership</span>
            </div>
            <h2>
              Play more. <em>Pay</em> less.
            </h2>
          </div>

          <div className="v2-plans">
            <div className="v2-plan">
              <span className="badge">Drop-in</span>
              <h3>
                Guest
                <br />
                Pass
              </h3>
              <div className="price">
                <span className="unit">from </span>$12<span className="unit">/player/hr</span>
              </div>
              <p className="muted">
                Per-court rates for padel and pickleball. Book up to 7 days out,
                free cancellation up to 24h ahead.
              </p>
              <ul className="features">
                <li>
                  <CheckIcon />
                  Padel from $12 / player / hr
                </li>
                <li>
                  <CheckIcon />
                  Pickleball $9 / player / hr
                </li>
                <li>
                  <CheckIcon />
                  Book 7 days in advance
                </li>
                <li>
                  <CheckIcon />
                  Free intro lesson included
                </li>
              </ul>
              <button type="button" className="v2-plan-cta" onClick={goBook}>
                Book a Court →
              </button>
            </div>

            <div className="v2-plan featured">
              <span className="badge">Most popular</span>
              <h3>
                Tempo
                <br />
                Premium
              </h3>
              <div className="price">
                $49<span className="unit">.99/mo</span>
              </div>
              <p className="muted">
                The balance of flexibility and value. Priority bookings, 25% off
                every court, wellness access.
              </p>
              <ul className="features">
                <li>
                  <CheckIcon />
                  Book 21 days in advance
                </li>
                <li>
                  <CheckIcon />
                  25% off padel &amp; pickleball
                </li>
                <li>
                  <CheckIcon />
                  Sauna &amp; ice bath access
                </li>
                <li>
                  <CheckIcon />
                  Pro-shop discounts
                </li>
              </ul>
              <button type="button" className="v2-plan-cta" onClick={goBook}>
                Join Premium →
              </button>
            </div>

            <div className="v2-plan">
              <span className="badge">Pickleball obsessed</span>
              <h3>
                Pickleball
                <br />
                Unlimited
              </h3>
              <div className="price">
                $79<span className="unit">.99/mo</span>
              </div>
              <p className="muted">
                Non-stop action on the pickleball courts. Unlimited bookings for
                your share of any 4-person game, plus open play.
              </p>
              <ul className="features">
                <li>
                  <CheckIcon />
                  Unlimited pickleball court time
                </li>
                <li>
                  <CheckIcon />
                  21-day priority booking
                </li>
                <li>
                  <CheckIcon />
                  Sauna &amp; ice bath access
                </li>
                <li>
                  <CheckIcon />
                  Pro-shop discounts
                </li>
              </ul>
              <button type="button" className="v2-plan-cta" onClick={goBook}>
                Join Unlimited →
              </button>
            </div>
            <article className="v2-plan" id="padel-morning-membership" aria-labelledby="padel-morning-membership-heading">
              <span className="badge">Morning play</span>
              <h3 id="padel-morning-membership-heading">
                Padel Morning
                <br />
                Membership
              </h3>
              <div className="price">
                $60<span className="unit">/month</span>
              </div>
              <p className="muted">A membership for your morning routine.</p>
              <ul className="features">
                <li>
                  <CheckIcon />
                  9 hours of morning court time
                </li>
                <li>
                  <CheckIcon />
                  1 sauna &amp; cold plunge visit each month
                </li>
                <li>
                  <CheckIcon />
                  20% off up to 4 Volley sessions each month
                </li>
                <li>
                  <CheckIcon />
                  A monthly coffee perk
                </li>
              </ul>
              <a className="v2-plan-cta" href="mailto:info@tempo.club?subject=Padel%20Morning%20Membership">
                Ask about Membership <ArrowIcon />
              </a>
            </article>
          </div>

          <div className="v2-ptable-wrap">
            <div className="v2-ptable-label">Price list · at a glance</div>
            <table className="v2-ptable">
              <thead>
                <tr>
                  <th>Service</th>
                  <th>Guest</th>
                  <th>Premium</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Padel · 60 min / player</td>
                  <td className="num" data-label="Guest">from $12</td>
                  <td className="tick num" data-label="Premium">−25%</td>
                </tr>
                <tr>
                  <td>Pickleball · 60 min / player</td>
                  <td className="num" data-label="Guest">$9</td>
                  <td className="tick num" data-label="Premium">−25%</td>
                </tr>
                <tr>
                  <td>Book in advance</td>
                  <td data-label="Guest">7 days</td>
                  <td className="tick" data-label="Premium">21 days</td>
                </tr>
                <tr>
                  <td>Free cancellation window</td>
                  <td data-label="Guest">24 hours</td>
                  <td className="tick" data-label="Premium">12 hours</td>
                </tr>
                <tr>
                  <td>Pro-shop discount</td>
                  <td data-label="Guest">—</td>
                  <td className="tick" data-label="Premium">✓</td>
                </tr>
                <tr>
                  <td>Wellness access (sauna · ice)</td>
                  <td data-label="Guest">—</td>
                  <td className="tick" data-label="Premium">✓</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* VISIT */}
      <section className="v2-section" id="visit" style={{ paddingBottom: 0 }}>
        <div className="v2-visit">
          <div className="v2-visit-content">
            <h3>1729 Brittmoore Rd, Ste A, Houston TX</h3>
            <p>
              In the heart of Spring Branch, minutes from Memorial and the
              Energy Corridor. Free on-site parking.
            </p>

            <div className="v2-visit-list">
              <a className="item" href="mailto:info@tempo.club">
                <span className="lbl">Email</span>
                <span className="val">info@tempo.club</span>
                <span className="go">→</span>
              </a>
              <a className="item" href="tel:+17135706716">
                <span className="lbl">Phone</span>
                <span className="val">+1 713 570 6716</span>
                <span className="go">→</span>
              </a>
              <a
                className="item"
                href="https://www.instagram.com/tempopadelclub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="lbl">Instagram</span>
                <span className="val">@tempopadelclub</span>
                <span className="go">→</span>
              </a>
              <div className="item">
                <span className="lbl">Hours</span>
                <span className="val">Mon–Sun · 7am–11:30pm</span>
                <span className="go">→</span>
              </div>
            </div>

            <div className="v2-visit-actions">
              <a
                className="v2-btn v2-btn-on-light"
                href="https://maps.google.com/?q=1729+Brittmoore+Rd+Ste+A+Houston+TX+77043"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
              <a className="v2-btn v2-btn-ghost" href="tel:+17135706716">
                Call the Club
              </a>
            </div>
          </div>

          <div className="map" aria-label="Map of Tempo location">
            <iframe
              title="Tempo location"
              src="https://maps.google.com/maps?cid=12622223130325733714&output=embed"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="v2-foot">
        <div className="v2-container">
          <div className="v2-foot-mark-wrap">
            <div className="v2-foot-mark"><TempoWordmark /></div>
          </div>

          <div className="v2-foot-grid">
            <div>
              <h4>Club</h4>
              <p>
                A padel &amp; pickleball club in Houston, Texas. Courts, wellness,
                and a place to unwind.
              </p>
            </div>
            <div>
              <h4>Play</h4>
              <ul>
                <li>
                  <a href="#courts">Courts</a>
                </li>
                <li>
                  <a href="#membership">Membership</a>
                </li>
                <li>
                  <Link to="/mornings">Mornings</Link>
                </li>
                <li>
                  <Link to="/events">Events</Link>
                </li>
                <li>
                  <Link to="/coaching">Coaching</Link>
                </li>
                <li>
                  <Link to="/free-intro">Free Intro</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Visit Us</h4>
              <ul>
                <li>
                  <a href="#visit" className="v2-foot-location">
                    <span>Brittmoore</span>
                    <span className="v2-foot-address">1729 Brittmoore Rd, Ste A, Houston</span>
                  </a>
                </li>
                <li>
                  <a href="#heights" className="v2-foot-location">
                    <span>Heights · Coming soon</span>
                    <span className="v2-foot-address">8200 Washington Ave, Houston</span>
                  </a>
                </li>
                <li>
                  <a href="mailto:info@tempo.club">info@tempo.club</a>
                </li>
                <li>
                  <a href="tel:+17135706716">+1 713 570 6716</a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/tempopadelclub"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @tempopadelclub
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4>Follow</h4>
              <ul>
                <li>
                  <a
                    href="https://instagram.com/tempopadelclub"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="#visit">Contact</a>
                </li>
                <li>
                  <a href="#membership">Pricing</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="v2-foot-bottom">
            <span>© Tempo 2026. All rights reserved.</span>
            <span>Made in Houston</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
